import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FileItem, FileLikeObject, FileUploader} from 'ng2-file-upload';
import {ToastControl} from '../../../controls/core/toast/toast.control';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent implements OnInit, OnChanges {

    @Input() maxFileCount = 10;
    @Input() maxSizeInMo = 30;
    @Input() allowedFileExtensions: string[] = [];
    @Output() filedAddedEvent: EventEmitter<FileItem> = new EventEmitter<FileItem>();
    @Output() queueChangedEvent: EventEmitter<FileItem[]> = new EventEmitter<FileItem[]>();

    disabled = false;
    fileUploader: FileUploader = new FileUploader({});
    hasBaseDropZoneOver = false;

    constructor(private toastControl: ToastControl) {
    }

    get extensionsAsText(): string {
        if (this.allowedFileExtensions?.length === 0) {
            return '';
        }
        return '(' + this.allowedFileExtensions.map(value => '.' + value).join(', ') + ')';
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['maxSizeInMo'] && this.maxSizeInMo) {
            this.fileUploader.options.maxFileSize = 1024 * 1024 * this.maxSizeInMo;
        }
    }

    ngOnInit() {
        this.fileUploader.options.queueLimit = 1;

        this.fileUploader.onWhenAddingFileFailed = (item: any, filter: any, options: any) => {
            switch (filter.name) {
                case 'fileSize':
                    this.toastControl.presentError(undefined, 'La taille maximale autorisée est de ' + this.maxSizeInMo + '  Mo');
                    break;
                default:
                    this.toastControl.presentError(undefined, 'Le fichier ne peut être pris en charge');
                    break;
            }
        };

        this.fileUploader.onAfterAddingFile = (item: FileItem) => {
            if (this.allowedFileExtensions?.length === 0 || this.hasFileNameAllowExtension(item.file.name)) {
                // console.logByType'Write file name ' + item.file.name);
                if (this.filedAddedEvent) {
                    this.filedAddedEvent.emit(item);
                }
            } else {
                // console.logByType'Wrong file name ' + item.file.name);
                this.fileUploader.queue.pop();
            }
            this.queueChangedEvent.emit(this.fileUploader.queue);
            this.refreshDisabled();
        };
    }

    private refreshDisabled() {
        this.disabled = this.uploadedFiles.length >= this.maxFileCount;
    }

    fileOverDropZone(ev): void {
        this.hasBaseDropZoneOver = ev;
    }

    get uploadedFiles(): FileLikeObject[] {
        return this.fileUploader.queue.map((fileItem) => {
            return fileItem.file;
        });
    }

    reset() {
        this.fileUploader.clearQueue();
        this.queueChangedEvent.emit(this.fileUploader.queue);
        this.refreshDisabled();
    }

    hasFileNameAllowExtension(fileName: string): boolean {
        return this.allowedFileExtensions.findIndex(value =>  fileName.toUpperCase().indexOf('.' + value.toUpperCase()) > -1) > -1;
    }

    onPaste(event: ClipboardEvent) {
        console.log(['on paste', event]);
        if (event.clipboardData.files?.length > 0) {
            this.fileUploader.addToQueue([event.clipboardData.files.item(0)]);
        }
    }


}
